// extracted by mini-css-extract-plugin
export default {"background":"spinnerForImg_background__zHOin","ldsRing":"spinnerForImg_ldsRing__6wgKZ"};